/**
 * 关于api层的方法
 * author: zhihuaw
 */
import envHelper from './envHelper.js'
const _ = {}

/**
 * 异常ip监控方法
 * @param {Object} api接口返回值
 */
_.ipMonitor = function(res) {
  if (res.wafcode === 999 || res.wafcode === 998) {
    if (res.data && res.data.redirectURL) {
      window.location.href = res.data.redirectURL
    }
  }
  if (res.monitorcode === 999) {
    let currentEnv = envHelper.getTujiaEnv()
    window.location.href = `https://m${currentEnv === 'fvt' ? '.' : ''}${currentEnv}.tujia.com/pwa/verify_code?returnurl=${encodeURIComponent(window.location.href)}&host=${res.host}`
  }
}

/**
 * api 业务异常监控，当成功信息无法正常取到时调用
 * @param {string} url api url
 * @param {Object} res api接口返回值
 * @param {Number} errorCode api错误码
 */
_.apiMonitor = function(url, res, errorCode) {
  if (!res) return
  try {
    if (res.wafcode) {
      _.ipMonitor(res)
      setApiBusinessCustomError(url, res, res.wafcode)
    } else if (res.monitorcode) {
      _.ipMonitor(res)
      setApiBusinessCustomError(url, res, res.monitorcode)
    } else if (errorCode) {
      setApiBusinessCustomError(url, res, errorCode)
    }
  } catch (error) {
    console.error(error)
  }
}

/**
 * 设置API错误自定义上报
 * @param {string} url api url
 * @param {Object} res api接口返回值
 * @param {string} errorCode  api error code
 */
function setApiBusinessCustomError(url, res, errorCode) {
  if (!(window._fas && window._fas.setCustomError)) return
  if (!errorCode || errorCode === '0' || errorCode === 0 || errorCode === -1000) return
  let apiMsgKey = 'BUSINESS'
  if(errorCode === 1000){
    apiMsgKey =  'HTTP_STATUS'
  }
  window._fas.setCustomError({
    message: `API ${apiMsgKey} ERROR: errorCode=${errorCode} url=${getUrlByRemoveQuerys(url)}`,
    level: 3,
    error: {
      url,
      res
    }
  })
}

/**
 * 获取无参数URL
 * @param {string} url URL
 */
function getUrlByRemoveQuerys(url) {
  if (url && url.indexOf('?')) {
    return url.split('?')[0]
  }
  return url
}

export default _
